import {clsx, type ClassValue} from 'clsx';
import {twMerge} from 'tailwind-merge';

/**
 * Utility for merging Tailwind CSS classes with proper conflict resolution
 * Combines clsx for conditional classes and tailwind-merge for deduplication
 * @example cn('p-2', 'p-4') → 'p-4' (later class wins)
 * @example cn('p-2', condition && 'p-4') → 'p-2' or 'p-4' based on condition
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
